import { LOGIN_PATH, LOGOUT_PATH } from "@/shared/constants/routePaths"

export function redirectToLogin() {
  const currentPath = window.location.pathname + window.location.search
  const isAuthPath = currentPath.startsWith(LOGIN_PATH) || currentPath.startsWith(LOGOUT_PATH)
  const redirect = isAuthPath ? "" : `?redirect=${encodeURIComponent(currentPath)}`
  window.location.href = `${LOGIN_PATH}${redirect}`
}
